import { Button, Form, Input, Modal } from "antd";
import { useMutation, useQueryClient } from "react-query";
import { createPlatformRate, createRate, updateRate } from "../../api/rate";
import { showErrorToast, showSuccessToast } from "../../utils/toast";
import { useEffect, useState } from "react";
import { useForm } from "antd/es/form/Form";
import UploadImages from "../products/upload";

const AddPlatformRate = ({ open = false, setOpen, data }) => {
  const queryClient = useQueryClient();
  const [form] = useForm();

  const mutation = useMutation(createPlatformRate, {
    onSuccess: () => {
      queryClient.invalidateQueries("platform-rate");
      showSuccessToast("Changes updated");
      setOpen(false);
    },
    onError: (e) => {
      showErrorToast(e.message);
    },
  });

  const onFinish = (values) => {
    mutation.mutate(values);
  };

  useEffect(() => {
    if (data) {
      form.setFieldValue("rate", data.rate);
    }
  }, [data]);

  return (
    <Modal
      title={
        "Add Platform Rate"
      }
      open={open}
      footer={null}
      onCancel={() => setOpen(false)}
    >
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Form.Item name="rate" label="Rate">
          <Input placeholder={"1300"} />
        </Form.Item>

        <Button
          className="bg-dark text-white rounded-[5px] font-bold text-[15px]"
          htmlType="submit"
          loading={mutation.isLoading}
        >
          Save Changes
        </Button>
      </Form>
    </Modal>
  );
};

export default AddPlatformRate;
